import { useEffect, useState } from "react";

/** Below Tailwind's `md`: where the pickers open as bottom sheets, as the other pickers switch layout. */
export const SHEET_QUERY = "(max-width: 767px)";

const read = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(SHEET_QUERY).matches;

/**
 * Is the page at a phone width (under 768px)? False where there is no matchMedia (tests,
 * old browsers), so a missing API leaves the desktop popovers.
 */
export const useIsSheet = (): boolean => {
  const [match, setMatch] = useState(read);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(SHEET_QUERY);
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener ? mq.addEventListener("change", on) : mq.addListener(on);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", on) : mq.removeListener(on);
    };
  }, []);
  return match;
};
